<template>
  <wrap-container class="container">
    <a href="https://www.bbva.com.ar/empresas.html">
      <wrap-container class="text-container">
        <p>
          Si querés conocer más sobre nuestros productos para empresas<br />
          ingresá a <strong>bbva.com.ar/empresas</strong>
        </p>
      </wrap-container>
    </a>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "Help",
  components: {
    WrapContainer
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  margin-top: 100px;
  margin-bottom: 100px;
}

img {
  align-self: flex-end;
  padding-right: 22px;
}

.text-container {
  align-self: flex-end;
  line-height: 0.2em;
}

.tel {
  font-weight: bold;
  line-height: 0.2em;
}

p {
  font-size: 14px;
}

a {
  display: flex;
  text-decoration: none;
  color: #2c3e50;
}

@media screen and (max-width: 600px) {
  img {
    display: none;
  }
}
</style>
